import {LoginPage} from './login/login';
import {SubmitPersonalInfoPage} from './account/submitinfo/submitinfo';
import {SetPasswordPage} from './account/setpwd/setpwd';
import {RecoverPasswordPage} from './account/recoverpwd/recoverpwd';
import {RetrieveListPage} from './password/items/list';
import {RetrieveItemPage} from './password/item/item';
import {VerifyByPhoneFirstPage} from './password/types/byphone/first/byphonefirst';
import {VerifyByPhoneMainPage} from './password/types/byphone/main/byphonemain';
import {VerifyByQuestionPage} from './password/types/byquestion/byquestion';
import {Deblocking} from '../deblocking/deblocking';
import {GestureLoginPage} from './gesturelogin/gesturelogin';
import {BindEmailPage} from './email/bind//bindEmail';
import {ModifyPasswordPage} from './password/modify/modifyPwd';

/*
 * 登录页下的所有组件
 */
export const LOGIN_INDEX = [
  LoginPage,
  SubmitPersonalInfoPage,
  SetPasswordPage,
  RecoverPasswordPage,
  RetrieveListPage,
  RetrieveItemPage,
  VerifyByPhoneFirstPage,
  VerifyByPhoneMainPage,
  VerifyByQuestionPage,
  Deblocking,
  GestureLoginPage,
  BindEmailPage,
  ModifyPasswordPage
];


// WEBPACK FOOTER //
// ./src/pages/login/index.ts